
import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 bg-[length:400%_100%]",
        className
      )}
      style={{ 
        animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite, gradient 2s ease infinite" 
      }}
      {...props}
    />
  )
}

export { Skeleton }
